import { Application } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

window.bootstrap = bootstrap

import AppController from "./controllers/app_controller"
import "./widgets"

const application = Application.start()
application.debug = false
application.register("wbd-app", AppController)
window.Stimulus = application
